import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8be5450"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center mb-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-900 me-2" }, "Lux", -1))
const _hoisted_3 = {
  key: 0,
  class: "badge badge-light-warning fs-8"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-text fs-8 me-1" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("writeup ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "text-gray-500 fs-8 mt-2" }
const _hoisted_9 = {
  key: 1,
  class: "symbol symbol-40px ms-3 mt-1"
}
const _hoisted_10 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LuxAvatar = _resolveComponent("LuxAvatar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex mb-6", _ctx.isUser ? 'justify-content-end' : 'justify-content-start'])
  }, [
    (!_ctx.isUser)
      ? (_openBlock(), _createBlock(_component_LuxAvatar, {
          key: 0,
          size: 40,
          class: "me-3 mt-1"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["lux-bubble", _ctx.isUser ? 'lux-bubble--user' : 'lux-bubble--lux'])
    }, [
      (!_ctx.isUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            (_ctx.message.used_writeup)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_6))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref: "body",
        class: "lux-bubble__body",
        innerHTML: _ctx.rendered
      }, null, 8, _hoisted_7),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.time), 1)
    ], 2),
    (_ctx.isUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("img", {
            src: _ctx.avatar,
            alt: ""
          }, null, 8, _hoisted_10)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}